import { Component, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { LoadingService } from 'src/app/services/loading.service';
import { StepsClientTypes, StepsNotClientTypes } from 'src/app/shared/enums';
import { UiActions } from 'src/app/store/actions';
import { OnboardingProductsStore } from 'src/app/store/store';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.scss']
})
export class CommonModalComponent implements OnInit, OnDestroy {
  ui$ = this.store.pipe(select(OnboardingProductsStore.selectors.ui));
  uiSub;
  staticAssetsUrl = environment.staticScripts.staticAssets;
  nextRedirect: StepsClientTypes | StepsNotClientTypes | undefined;

  constructor(
    public loadingService: LoadingService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  ngOnInit(): void {
    this.uiSub = this.ui$.subscribe((ui) => {
      this.nextRedirect = ui.redirect;
    });
  }

  modalResolution() {
    if (this.nextRedirect) {
      this.store.dispatch(UiActions.ModalResolution());
    } else {
      this.store.dispatch(
        UiActions.ToggleModal({
          open: false,
          redirect: undefined
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.uiSub.unsubscribe();
  }
}
